import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useState, useContext } from "react";
import { useRouter } from "next/navigation";
import Item from "./Item";
import { NotificationsContext } from "@lib/notifications/NotificationsContext";
import Menu from "./Menu";
import { Divider, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import useMarkAsRead from "@lib/user/useMarkAsRead";

export default function Notifications() {
  const router = useRouter();
  const [unread, setUnread] = useState(0);
  const { notifications, isFetching } = useContext(NotificationsContext);
  const markAsRead = useMarkAsRead();
  const [anchorEl, setAnchorEl] = useState(null);

  const unreadCount = notifications?.filter((n) => !n.read).length ?? 0;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    const unreadNotifications = notifications.filter((n) => !n.read).map((n) => n.id);
    markAsRead.mutate(unreadNotifications);
    setUnread(0);
    setAnchorEl(null);
  };

  // Refresh the unread badge once a fetch settles. Done during render on the
  // falling edge of isFetching (React's replacement for a set-state-in-effect),
  // preserving the previous [isFetching]-only trigger so a manual clear on
  // close isn't immediately overwritten.
  const [prevIsFetching, setPrevIsFetching] = useState(isFetching);
  if (isFetching !== prevIsFetching) {
    setPrevIsFetching(isFetching);
    if (!isFetching) {
      setUnread(unreadCount);
    }
  }

  return (
    <>
      <IconButton color="inherit" onClick={handleClick}>
        <Badge
          badgeContent={unread}
          color="secondary"
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <img src="/img/floats/bell.svg" alt="Notifications" />
        </Badge>
        <ArrowDropDownIcon />
      </IconButton>
      {notifications && (
        <Menu
          id="user-menu"
          anchorEl={anchorEl}
          onClose={handleClose}
          labelledBy={"user-menu-button"}
        >
          <List sx={{ width: "100%" }}>
            {notifications.length === 0 ? (
              <ListItem>
                <ListItemText
                  primary="No notifications yet"
                  primaryTypographyProps={{ color: "text.secondary", textAlign: "center" }}
                />
              </ListItem>
            ) : (
              notifications.map((notification, index) => (
                <Item key={index} notification={notification} handleClose={handleClose} />
              ))
            )}
          </List>
          <Divider sx={{ position: "sticky", bottom: 44, zIndex: 1 }} />
          {/* ListItemButton (not ListItem) so the row is focusable and
              activatable by keyboard, not just clickable. */}
          <ListItemButton
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 1,
              // Blue / Informational (styleguide color token)
              backgroundColor: "#EDF4FE",
            }}
            onClick={() => {
              router.push("/notifications");
              handleClose();
            }}
          >
            <ListItemText
              primary="View all notifications"
              primaryTypographyProps={{ color: "primary", fontWeight: 600, textAlign: "center" }}
            />
          </ListItemButton>
        </Menu>
      )}
    </>
  );
}
